import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import styles from '../../MenuItem.module.scss';
import { ReactComponent as IconBookings } from '../../../../assets/icons/icon_bookings-menu.svg';
import { BOOKING_URL } from '../../../new-booking/Enum';
import { UserTypes } from '../../../../domains/user/user-types';

// Inline styles with the tooltip positioned BELOW the navbar
const tooltipStyles = {
  position: 'absolute',
  top: '66px', // Position below the navbar instead of above
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'white',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  padding: '8px 12px',
  fontSize: '14px',
  whiteSpace: 'nowrap',
  color: 'rgb(51, 51, 51)',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  gap: '6px'
};

// Modified arrow to point UPWARD from the tooltip (since it's now below)
const tooltipArrowStyles = {
  position: 'absolute',
  top: '-6px', // Position at the top of the tooltip
  left: '50%',
  transform: 'translateX(-50%)',
  width: 0,
  height: 0,
  borderLeft: '6px solid transparent',
  borderRight: '6px solid transparent',
  borderBottom: '6px solid white' // Point upward
};

const IconStyles = {
  display: 'inline-block',
  fontSize: '16px',
  marginRight: '4px'
};

const BookingsButton = ({ introClass, handleMenuLinkClick, mustTakeIntroClass, selectedCourse, user, socialFeaturesData }) => {
  // Check if any of the social features are enabled
  const showPeerMilestones = useFeatureIsOn('peer-milestones');

  // Show the tooltip whenever peer milestones feature is enabled
  const showTeammatesBookedTooltip = showPeerMilestones && socialFeaturesData?.data !== undefined;

  // Get the number of teammates who booked
  const teammatesNumber = socialFeaturesData?.data?.teammatesNumber || 0;

  // Determine the tooltip message based on the number of teammates
  let tooltipMessage = '';
  if (teammatesNumber === 0) {
    tooltipMessage = 'No teammates booked this week';
  } else if (teammatesNumber === 1) {
    tooltipMessage = '1 teammate booked this week';
  } else {
    tooltipMessage = `${teammatesNumber} teammates booked this week`;
  }

  if ((mustTakeIntroClass && introClass?.status !== 'happened') || (!mustTakeIntroClass && !Object.keys(selectedCourse).length)) {
    return null;
  }

  if (user?.user_type !== UserTypes.student) {
    return null;
  }

  return (
    <li className={styles['link-wrapper']} data-testid="bookings-button">
      <NavLink
        to={BOOKING_URL}
        onClick={() => handleMenuLinkClick('dashboard')}
        activeClassName={styles.isActive}
        className={`${styles.menuItem} BookingsTooltip hasTooltip`}
        data-testid="bookings-link"
        style={{ position: 'relative' }}>
        <div className={styles['button-wrapper']}>
          <div className={styles['background']}>
            <IconBookings />
          </div>
          <span>Bookings</span>
        </div>

        {/* Tooltip that shows the number of teammates who booked - now positioned BELOW */}
        {showTeammatesBookedTooltip && (
          <div className="BookingsTooltip_bookingTooltip__paZNT" style={tooltipStyles}>
            {/* Arrow pointing upward */}
            <div style={tooltipArrowStyles}></div>
            <span className="BookingsTooltip_tooltipIcon__8onSR" style={IconStyles}>
              👥
            </span>
            {tooltipMessage}
          </div>
        )}
      </NavLink>
    </li>
  );
};

BookingsButton.propTypes = {
  introClass: PropTypes.shape({ status: PropTypes.string }),
  handleMenuLinkClick: PropTypes.func.isRequired,
  mustTakeIntroClass: PropTypes.bool.isRequired,
  selectedCourse: PropTypes.object,
  user: PropTypes.object,
  socialFeaturesData: PropTypes.object
};

const mapStateToProps = (state) => ({
  socialFeaturesData: state.socialFeaturesData
});

export default connect(mapStateToProps)(BookingsButton);
